import { blue, gray, red } from '~/common/styles/colors'
import { MenuButtonVariant } from '../../menu-button/types'

/**
 * Returns the loading styles for the button container based on the variant
 */
export const getLoadingContainerPrimitives = (variant: MenuButtonVariant, loading: boolean) => {
  if (loading) {
    switch (variant) {
      case 'primary':
        return {
          backgroundColor: blue[9],
          color: 'transparent',
          cursor: 'auto',
          borderRadius: '2px',
          '&:hover': {
            color: 'transparent',
            backgroundColor: blue[10],
            borderRadius: '2px',
            cursor: 'auto',
          },
          '&:active': {
            color: 'transparent',
            backgroundColor: blue[11],
          },
          '&:focus': {
            color: 'transparent',
            backgroundColor: blue[10],
          },
        }
      case 'secondary':
        return {
          backgroundColor: gray[12],
          color: 'transparent',
          cursor: 'auto',
          borderRadius: '2px',
          '&:hover': {
            color: 'transparent',
            backgroundColor: gray[12],
            borderRadius: '2px',
            cursor: 'auto',
          },
          '&:active': {
            color: 'transparent',
            backgroundColor: gray[12],
          },
          '&:focus': {
            color: 'transparent',
            backgroundColor: gray[12],
          },
        }
      case 'ghost':
        return {
          backgroundColor: gray[10],
          color: 'transparent',
          cursor: 'auto',
          borderRadius: '2px',
          '&:hover': {
            color: 'transparent',
            backgroundColor: gray[10],
            borderRadius: '2px',
            cursor: 'auto',
          },
          '&:active': {
            color: 'transparent',
            backgroundColor: gray[10],
          },
          '&:focus': {
            color: 'transparent',
            backgroundColor: gray[10],
          },
        }
      case 'danger':
        return {
          backgroundColor: red[10],
          color: 'transparent',
          cursor: 'auto',
          borderRadius: '2px',
          '&:hover': {
            color: 'transparent',
            backgroundColor: red[10],
            borderRadius: '2px',
            cursor: 'auto',
          },
          '&:active': {
            color: 'transparent',
            backgroundColor: red[10],
          },
          '&:focus': {
            color: 'transparent',
            backgroundColor: red[10],
          },
        }
    }
  } else {
    return {}
  }
}
